import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, takeUntil, tap } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import {
  CustomResultOfPaginatedListOfGuildWithPaginationDto,
  GuildDto,
  GuildWithPaginationDto,
} from '../../../../app/core/api/models';
import { PaginatedListOfGuildWithPaginationDto } from '../../../core/api/models/paginated-list-of-guild-with-pagination-dto';
import { GuildsService } from '../../../core/api/services/guilds.service';
import { AppDomService } from '../../../core/services/dom.service';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { GuildsFormComponent } from './guilds-form/guilds-form.component';


@Component({
    selector: 'app-guilds',
    templateUrl: './guilds.component.html',
    imports: [BaseIndexModule]
})
export class GuildsComponent extends BaseIndexPageComponent implements OnInit {
  //#region Properties

  pageName = PageNames.guilds;

  // Binding service endpoints
  protected currentService = inject(GuildsService);
  paginationApiMethodName: string = this.currentService.guildsGetGuildsWithPagination.name;
  createGetApiMethodName: string = this.currentService.guildsCreateGet.name;
  deleteApiMethodName: string = this.currentService.guildsDelete.name;
  auditApiMethodName: string = this.currentService.guildsGetGuildsAudit.name;

  modelWithPagination$: Observable<PaginatedListOfGuildWithPaginationDto>;
  items$: Observable<Array<GuildWithPaginationDto>>;
  formPageConfig: FormPageConfig<GuildDto> = {};

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.name, name: 'name', hasSearch: true },
      { title: this.localizer.parent, name: 'ParentName', hasSearch: true },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get ById
  baseGetByIdApi(id: number): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .guildsUpdateGet({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserverFormModal);
  }


  //#endregion

  //#region call Actions

  openCreateFormModal() {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}addTitle`,
        isEdit: false,
      };

      const modalResult = this.dialogService.openModal({
        component: GuildsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          finalize(() => (this.pageConfig.isVisibleForm = undefined)),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  openEditFormModal(model: GuildDto) {
    try {
      this.unSubs();

      let data = {
        title: `${this.formPageConfig?.vocabs}editTitle`,
        model: { name: model.name, parentId: model.parentId },
        id: model.id,
        isEdit: true,
      };

      const modalResult = this.dialogService.openModal({
        component: GuildsFormComponent,
        data: data,
      });

      modalResult
        .afterClosed()
        .pipe(
          takeUntil(this.onDestroy$),
          tap(() => {
            AppDomService.removeModalScrollClassFromHtml();
          })
        )
        .subscribe((res) => {
          if (res) {
            this.getTableData();
            this.cd.detectChanges();
          }
        });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  //#endregion
}
